<template>
  <div
    class="config-form-content adminWeeducDomain weeduc-admin-config container-fluid domainsConfig weflix-admin-domain"
  >
    <TitlePage
      :title="$t('admin.siteConfig.domainTitle')"
      :subtitle="$t('admin.siteConfig.domainSubtitle')"
      :hasMargin="false"
    />

    <div class="settings-layout">
      <div class="settings-panel domain-settings-panel contetContainerEditVideo">
        <section class="domain-section">
          <h5 class="domain-section-title">{{ $t('admin.siteConfig.weeducDomain') }}</h5>
          <p class="domain-section-lead">
            {{ $t('admin.siteConfig.weeducDomainLead') }}
          </p>
          <p class="domain-callout">
            <strong>{{ $t('common.warning') }}:</strong> {{ $t('admin.siteConfig.domainUpdateWarning') }} <strong>{{ $t('admin.siteConfig.minutes20') }}</strong>.
          </p>
          <div class="form-group flex domain domain-fields-row domain-field-grid">
            <div class="form-group domain-field">
              <div class="form-label">
                <label>{{ $t('admin.siteConfig.weeducDomainName') }}</label>
              </div>
              <div class="form-input">
                <div class="flex domain_input domain-input-with-action">
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="$t('admin.siteConfig.myDomainPlaceholder')"
                    v-model="domainTutor"
                    @keyup="createFullDomain()"
                  />
                  <fa icon="fa-check icon_check" v-if="hasValidDomain === true" />
                  <fa icon="fa-times icon_check" v-if="hasValidDomain === false" />
                  <button type="button" class="btn verify" @click="validateDomain">{{ $t('admin.siteConfig.verify') }}</button>
                </div>
                <small class="small field-hint">{{ $t('admin.siteConfig.domainNameHint') }}</small>
              </div>
            </div>
            <div class="domainPreview domain-field">
              <div class="form-label">
                <label>{{ $t('admin.siteConfig.finalWeeducDomain') }}</label>
              </div>
              <div class="form-input">
                <div class="domain-value-copy-line">
                  <input
                    type="text"
                    class="form-control disabled"
                    :placeholder="$t('admin.siteConfig.finalDomainPlaceholder')"
                    v-model="fullDomainTutor"
                    disabled
                  />
                  <button
                    type="button"
                    class="domain-copy-btn domain-copy-btn--inline"
                    :aria-label="$t('admin.siteConfig.copyDomain')"
                    @click="copyToClipboard(fullDomainTutor)"
                  >
                    <i class="pi pi-copy"></i>
                  </button>
                </div>
                <small class="small field-hint">{{ $t('admin.siteConfig.publicStoreHint') }}</small>
              </div>
            </div>
          </div>
        </section>

        <div class="domain-section-spacer" aria-hidden="true" />

        <section class="domain-section">
          <h5 class="domain-section-title">{{ $t('admin.siteConfig.ownDomain') }}</h5>
          <p class="domain-section-lead">
            {{ $t('admin.siteConfig.ownDomainLead') }}
          </p>
          <p class="domain-callout">
            <strong>{{ $t('common.warning') }}:</strong> {{ $t('admin.siteConfig.ownDomainWarning') }} <strong>{{ $t('admin.siteConfig.hours24') }}</strong>.
          </p>

          <div class="form-group flex domain domain-field-grid domain-own-grid">
            <div class="col-form-inner domain-field">
              <div class="form-group">
                <div class="form-label">
                  <label>{{ $t('admin.siteConfig.primaryDomain') }}</label>
                </div>
                <div class="form-input">
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="$t('admin.siteConfig.urlPlaceholder')"
                    v-model="domainOwn"
                  />
                  <small class="small field-hint">{{ $t('admin.siteConfig.primaryDomainHint') }}</small>
                </div>
              </div>
            </div>
            <div class="col-form-inner domain-field">
              <div class="form-group">
                <div class="form-label">
                  <label>{{ $t('admin.siteConfig.additionalDomain') }}</label>
                </div>
                <div class="form-input">
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="$t('admin.siteConfig.urlPlaceholder')"
                    v-model="domainSecondary"
                  />
                  <small class="small field-hint">{{ $t('admin.siteConfig.additionalDomainHint') }}</small>
                </div>
              </div>
            </div>
          </div>

          <div class="dns-instructions">
            <h6 class="dns-instructions-title">{{ $t('admin.siteConfig.dnsTitle') }}</h6>
            <p class="dns-instructions-lead">{{ $t('admin.siteConfig.dnsLead') }}</p>
            <div class="info_pointer dns-cards">
              <div class="dns-card dns-card--split CNAME">
                <div class="dns-card-info">
                  <span class="dns-card-badge">CNAME</span>
                  <p class="dns-card-text">{{ $t('admin.siteConfig.cnameHint') }}</p>
                </div>
                <div class="dns-card-values">
                  <div class="form-input dns-value-row">
                    <input
                      type="text"
                      class="form-control disabled cname"
                      :value="dnsCnameTarget"
                      disabled
                      readonly
                    />
                    <button
                      type="button"
                      class="domain-copy-btn"
                      :aria-label="$t('admin.siteConfig.copyCname')"
                      @click="copyToClipboard(dnsCnameTarget)"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="dns-card dns-card--split A">
                <div class="dns-card-info">
                  <span class="dns-card-badge">{{ $t('admin.siteConfig.aRecord') }}</span>
                  <p class="dns-card-text">{{ $t('admin.siteConfig.aRecordHint') }}</p>
                </div>
                <div class="dns-card-values">
                  <div class="dns-ip-list">
                    <div class="form-input dns-value-row">
                      <input
                        type="text"
                        class="form-control disabled ip"
                        :value="aRecordIp1"
                        :placeholder="$t('admin.siteConfig.ip1Placeholder')"
                        disabled
                        readonly
                      />
                      <button
                        type="button"
                        class="domain-copy-btn"
                        :aria-label="$t('admin.siteConfig.copyIp')"
                        @click="copyToClipboard(aRecordIp1)"
                      >
                        <i class="pi pi-copy"></i>
                      </button>
                    </div>
                    <div class="form-input dns-value-row">
                      <input
                        type="text"
                        class="form-control disabled ip"
                        :value="aRecordIp2"
                        :placeholder="$t('admin.siteConfig.ip2Placeholder')"
                        disabled
                        readonly
                      />
                      <button
                        type="button"
                        class="domain-copy-btn"
                        :aria-label="$t('admin.siteConfig.copyIp')"
                        @click="copyToClipboard(aRecordIp2)"
                      >
                        <i class="pi pi-copy"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="info_doubt domain-help-foot">
            <p>
              {{ $t('admin.siteConfig.dnsHelp') }}
              <a href="" class="domain-help-link">{{ $t('admin.siteConfig.dnsTutorial') }}</a>.
            </p>
          </div>
        </section>
      </div>

      <div class="actions configGeneralWeflix">
        <v-btn variant="flat" color="primary" size="large" min-width="160" class="settings-save-btn" @click="save">
          {{ $t('admin.siteConfig.saveChanges') }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import apiSiteDomain from '@/utils/Site/domain'
import { toast } from 'vue3-toastify'
import TitlePage from '@/components/Weflix/titlePage.vue'

export default {
  name: 'AdminWeeducDomain',
  components: {
    TitlePage,
  },
  data() {
    return {
      domainTutor: '',
      fullDomainTutor: '',
      domainOwn: '',
      domainSecondary: '',
      hasValidDomain: null,
      dnsCnameTarget: 'sni.weeduc.tv',
      aRecordIp1: '',
      aRecordIp2: '',
    }
  },
  computed: {
    ...mapState(['token']),
  },
  methods: {
    createFullDomain() {
      if (this.domainTutor == null || this.domainTutor === '') {
        this.fullDomainTutor = ''
        return
      }
      this.domainTutor = String(this.domainTutor)
        .replace(/[^\w\s]/gi, '')
        .replace(/\s+/g, '')
        .toLowerCase()
      this.fullDomainTutor = `https://${this.domainTutor}.weeduc.com.br`
    },
    copyToClipboard(text) {
      if (text == null || text === '') return
      navigator.clipboard.writeText(String(text))
      toast.success(this.$t('admin.siteConfig.copied'))
    },
    async save() {
      const obj = {
        url: this.fullDomainTutor,
        url1: this.domainOwn,
        url2: this.domainSecondary,
      }
      try {
        await apiSiteDomain.putDomaintData(this.token, obj)
        await this.getDataDomain()
        toast.success(this.$t('admin.siteConfig.domainSaveSuccess'))
        this.$emit('save', true)
      } catch (error) {
        console.error(error)
        toast.error(this.$t('admin.siteConfig.saveDataError'))
      }
    },
    async getDataDomain() {
      try {
        const response = await apiSiteDomain.getDomainData(this.token)
        const rawUrl = response.url || ''
        if (rawUrl) {
          try {
            const host = rawUrl.replace(/^https?:\/\//i, '').split('/')[0]
            this.domainTutor = host.split('.')[0] || ''
          } catch {
            this.domainTutor = ''
          }
          this.fullDomainTutor = rawUrl.startsWith('http') ? rawUrl : `https://${rawUrl}`
        } else {
          this.domainTutor = ''
          this.fullDomainTutor = ''
        }
        this.domainOwn = response.url1 || ''
        this.domainSecondary = response.url2 || ''
        if (response.aRecordIp1 != null && response.aRecordIp1 !== '') {
          this.aRecordIp1 = response.aRecordIp1
        }
        if (response.aRecordIp2 != null && response.aRecordIp2 !== '') {
          this.aRecordIp2 = response.aRecordIp2
        }
      } catch (error) {
        console.error(error)
        toast.error(this.$t('admin.siteConfig.domainLoadError'))
      }
    },
    async validateDomain() {
      if (!this.fullDomainTutor) {
        toast.error(this.$t('admin.siteConfig.domainNameRequired'))
        return
      }
      const obj = { url: this.fullDomainTutor }
      try {
        const response = await apiSiteDomain.postVerifyDomaintData(this.token, obj)
        this.hasValidDomain = response
        if (response) {
          toast.success(this.$t('admin.siteConfig.domainAvailable'))
        } else {
          toast.error(this.$t('admin.siteConfig.domainUnavailable'))
        }
      } catch (error) {
        console.error(error)
        toast.error(this.$t('admin.siteConfig.domainVerifyError'))
      }
    },
  },
  created() {
    this.getDataDomain()
  },
}
</script>

<style scoped lang="scss">
@import url('@/components/Weflix/Config/css/domains.css');

.container-fluid.domainsConfig.weflix-admin-domain {
  max-width: 100% !important;
  width: 100% !important;
  margin: 0;
  padding: 0;
  min-height: 100%;
  position: relative;
  box-sizing: border-box;
}

.titleContainer {
  margin-bottom: 28px;
}

.titleContainer h3 {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 5px;
}

.titleContainer small {
  color: #666;
  font-size: 14px;
}

.settings-layout {
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.domain-settings-panel.settings-panel {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  background: transparent;
  border: none;
  border-radius: 0;
  box-shadow: none;
  overflow: visible;
}

.domain-section {
  text-align: left;
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box;
}

.domain-section-title {
  margin: 0 0 0.5rem;
  font-size: 1.0625rem;
  font-weight: 700;
  color: #111827;
  letter-spacing: -0.02em;
}

.domain-section-lead {
  margin: 0 0 0.75rem;
  font-size: 0.9375rem;
  line-height: 1.6;
  color: #4b5563;
  max-width: none;
}

.domain-section-lead:last-of-type {
  margin-bottom: 1rem;
}

.domain-callout {
  margin: 0 0 1.35rem;
  padding: 0.75rem 1rem;
  font-size: 0.8125rem;
  line-height: 1.55;
  color: #374151;
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 8px;
  max-width: none;
}

.domain-callout strong {
  color: #92400e;
}

.domain-section .form-label label {
  font-size: 0.8125rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.25rem;
}

.field-hint {
  display: block;
  margin-top: 0.4rem !important;
  font-size: 0.75rem !important;
  line-height: 1.4;
  color: #6b7280 !important;
}

.domain-section-spacer {
  height: 1px;
  margin: 1.75rem 0;
  background: linear-gradient(90deg, transparent, #e5e7eb 15%, #e5e7eb 85%, transparent);
  border: none;
}

.domain-field-grid {
  display: grid !important;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 2.5rem !important;
  row-gap: 1.5rem !important;
  gap: 1.5rem 2.5rem !important;
  width: 100% !important;
  margin: 0 !important;
  padding-left: 0 !important;
  flex-wrap: unset !important;
  align-items: start !important;
}

.domain-field-grid > .domain-field,
.domain-field-grid > .form-group.domain-field,
.domain-field-grid > .domainPreview.domain-field,
.domain-field-grid > .col-form-inner.domain-field {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0;
  flex: none !important;
}

.domain-own-grid {
  margin-bottom: 1.5rem !important;
}

.domain-input-with-action {
  position: relative;
  width: 100%;
  display: flex;
  align-items: stretch;
  gap: 0.75rem;
  flex-wrap: nowrap;
  min-width: 0;
}

.domain-input-with-action .form-control {
  flex: 1;
  min-width: 0;
}

.domain-value-copy-line {
  display: flex;
  align-items: stretch;
  gap: 1rem;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.domain-value-copy-line .form-control {
  flex: 1;
  min-width: 0;
}

.domainPreview.domain-field .form-input {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.domain-copy-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 2.5rem;
  min-height: 2.5rem;
  padding: 0;
  border: none;
  border-radius: 8px;
  background: #f3f4f6;
  color: #250891;
  cursor: pointer;
  transition:
    background 0.15s ease,
    color 0.15s ease;
}

.domain-copy-btn--inline {
  position: static;
  transform: none;
}

.domain-copy-btn:hover {
  background: #e8e4f5;
  color: #1a0668;
}

.domain-copy-btn .pi {
  font-size: 0.95rem;
}

.dns-instructions {
  margin-top: 0.25rem;
}

.dns-instructions-title {
  margin: 0 0 0.25rem;
  font-size: 0.875rem;
  font-weight: 700;
  color: #1f2937;
}

.dns-instructions-lead {
  margin: 0 0 1rem;
  font-size: 0.8125rem;
  color: #6b7280;
}

.dns-cards.info_pointer {
  display: grid !important;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
  margin-top: 0 !important;
  padding: 0 !important;
  width: 100%;
}

.dns-cards.info_pointer > div {
  width: 100% !important;
}

.dns-card {
  padding: 1rem 1.1rem;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.dns-card.dns-card--split {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem 1.5rem;
  flex-wrap: wrap;
}

.dns-card-info {
  flex: 1 1 14rem;
  min-width: min(100%, 11rem);
  max-width: 100%;
}

.dns-card-info .dns-card-text {
  margin-bottom: 0;
}

.dns-card-values {
  flex: 1 1 14rem;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
}

.dns-card-values .dns-ip-list {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.5rem;
}

.dns-card .form-input.dns-value-row {
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: nowrap !important;
  align-items: stretch;
  width: auto !important;
  max-width: 100% !important;
  min-width: 0;
  gap: 0.75rem;
  margin: 0 !important;
  padding: 0 !important;
  box-sizing: border-box;
}

.dns-card .dns-value-row .form-control {
  flex: 1 1 auto;
  min-width: 10rem;
  max-width: min(24rem, 70vw);
  width: auto !important;
}

.dns-card-badge {
  display: inline-block;
  margin-bottom: 0.5rem;
  padding: 0.2rem 0.55rem;
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #250891;
  background: #ede9fe;
  border-radius: 6px;
}

.dns-card-text {
  margin: 0.35rem 0 0;
  font-size: 0.8125rem;
  line-height: 1.5;
  color: #4b5563;
}

.dns-card-text code {
  font-size: 0.8em;
  padding: 0.1rem 0.35rem;
  background: #f3f4f6;
  border-radius: 4px;
  color: #1f2937;
}

.dns-card .dns-value-row .domain-copy-btn {
  width: 2.5rem;
  min-height: 2.5rem;
  flex-shrink: 0;
}

.domain-help-foot {
  margin-top: 1.25rem;
  padding: 0.85rem 1rem;
  background: #f9fafb;
  border-radius: 8px;
  border: 1px solid #f0f2f5;
}

.domain-help-foot p {
  margin: 0;
  font-size: 0.8125rem;
  line-height: 1.5;
  color: #6b7280;
}

.domain-help-link {
  color: #250891;
  font-weight: 600;
  text-decoration: none;
}

.domain-help-link:hover {
  text-decoration: underline;
}

.domain-fields-row {
  margin-top: 0 !important;
}

.container-fluid.domainsConfig.weflix-admin-domain .domain-settings-panel .form-group.flex.domain .col-form-inner.col-6.col-md-6.col-lg-6 {
  margin-top: 0 !important;
  cursor: default !important;
}

.actions.configGeneralWeflix {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  padding: 0;
  margin: 0;
  position: relative;
  bottom: auto;
  right: auto;
}

.settings-save-btn {
  font-weight: 600;
  letter-spacing: 0.02em;
}

@media (max-width: 768px) {
  .container-fluid.domainsConfig.weflix-admin-domain {
    padding: 0;
  }

  .domain-field-grid,
  .dns-cards.info_pointer {
    grid-template-columns: 1fr !important;
  }

  .dns-card.dns-card--split {
    flex-direction: column;
  }

  .dns-card-values {
    align-items: stretch !important;
    width: 100%;
    max-width: 100%;
  }

  .dns-card-values .dns-ip-list {
    align-items: stretch;
  }

  .dns-card .form-input.dns-value-row {
    width: 100% !important;
    max-width: 100% !important;
  }

  .dns-card .dns-value-row .form-control {
    max-width: none;
    min-width: 0;
  }

  .actions.configGeneralWeflix .settings-save-btn {
    width: 100%;
  }
}
</style>
